import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { environment } from '../environments/environment';

const authToken = JSON.parse(localStorage.getItem('user_token'));
const http_options = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': `${authToken}`
  })
};

class GPForm {
  gp_date:string;
  gp_number:string;
  station: string;
  consignor: string;
  loading: string;
  gatePassNumber: string;
  on_account: string;
  party:string;
  truck_number: string;
  owned_by: string;
  product: string;
  weight:string;
  qty_bags:string;
  rr_number : string;
  rr_date: string;
  sto_number : string;
}

@Injectable()
export class GatePassService {

private url = environment.url;

  constructor(private http: HttpClient) { }


  addNewGatePass(form): Observable<string>{
  	return this.http.post<string>(this.url + '/gatepass/submit', form, http_options);
  }

  getGPFormWith(id:number): Observable<GPForm[]> {
    console.log (this.http.get<GPForm[]>(this.url + '/gatepass/get/' + id, http_options));
    return this.http.get<GPForm[]>(this.url + '/gatepass/get/' + id, http_options);
  }
  getGPFormByRRNumber(rr_number:string): Observable<GPForm[]> {
    return this.http.get<GPForm[]>(this.url + '/gatepass/get/byrrnumber/' + rr_number, http_options);
  }
  getLastGPNumber(id:string): Observable<GPForm[]> {
    return this.http.get<GPForm[]>(this.url + '/gatepass/getlastgpnumber/' + id, http_options);
  }

}



// WEBPACK FOOTER //
// /Users/meghneel/work/baba_frontend/src/app/gate-pass.service.ts